<template>
  <div class="container d-flex flex-column justify-content-between text-center" :style="{ height: altura }">
    <div class="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
      <img 
        src="https://img.icons8.com/?size=100&id=83205&format=png&color=00A591" 
        alt="Ícone de sucesso" 
        style="width: 3rem; height: 3rem; margin-bottom: 20px;"
      />
      <p class="text-secondary" style="font-weight: bolder; margin: 0;">Nº {{ numFicha }}</p>
      <p class="text-secondary" style="margin:0;">Ficha de decisão atualizada com sucesso.</p>
    </div>
    <div class="mt-auto w-100">
      <router-link :to="'/nova_ficha'">
        <button class="btn btn-outline-primary w-100 py-3 nova_decisao" style="margin-bottom: 10px !important;">
          Cadastrar nova decisão
        </button>
      </router-link>

      <router-link :to="'/lista'">
        <button class="btn btn-outline-secondary w-100 py-3" style="margin-bottom: 10px !important;">
          Ver fichas de decisões
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AtualizadoSucesso",

  data() {
    return {
      numFicha: this.$route.params.num_ficha,
      altura: "100vh"
    };
  },
  mounted() {
      this.detectarDispositivo();
  },
  methods: {
      detectarDispositivo() {
          if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              // É um dispositivo mobile
              this.altura = "90vh";
          } else {
              this.altura = "100vh";
          }
      },
  },


};
</script>

<style scoped>
  .nova_decisao {
    margin-bottom: 10px;
    background-color: #136A9F;
    color: white;
    font-weight: bolder;
    border: 1px solid #136A9F !important;
  }

  .nova_decisao:hover {
    background-color: transparent !important;
    color: #136A9F !important;
    border: 1px solid #136A9F !important;
  }

  .text-secondary {
    color: #969EA4 !important;
  }

  .btn-outline-secondary {
    font-weight: bolder;
    border: 1px solid #969EA4;
    color: #969EA4;
    margin-bottom: 10px;
  }

  .btn-outline-secondary:hover {
    background-color: #969EA4 !important;
    color: white !important;
    border: 1px solid #969EA4 !important;
  }

  button {
    border-radius: 8px;
  }
</style>
